import React from 'react';
import '../../../../../sass/apps/commerce/desktop/upgrade_information_content/upgrading_benefits.scss';

const UpgradingBenefits = (props) => (
  <div className="upgrading-benefits">
    <div className="upgrading-benefits__bold">
      <h3 className="upgrading-benefits__heading">A Bold Ad</h3>
      <p>
        <b className="in_short">Rent or find a room faster</b>
        Whether you are looking for or renting a room you get results faster
        with a Bold Ad. Here{`'`}s why:
      </p>
      <p>
        <b className="in_short">Double your {props.localisations.enquiries}</b>
        Bold Ads get (on average) twice as many {props.localisations.enquiries}.
      </p>
      <p>
        <b className="in_short">Free for ALL to contact you</b>
        Bold Ads can be contacted from day one without the user requiring Early
        Bird access.
      </p>
      <p>
        <b className="in_short">Keep your ad near the top of the listings</b>
        Bold Ads are ranked higher in the search results than Free Ads.
      </p>
      <p>
        <b className="in_short">Higher visibilty</b>
        Bold Ads stand out on the search results page.
      </p>
    </div>

    <div className="upgrading-benefits__early-bird">
      <h3 className="upgrading-benefits__heading">Early Bird Access</h3>
      <p>
        <b className="in_short">Contact all ads</b>
        Early Bird Access means there are no restrictions on which ads you can
        contact.
      </p>
      <p>
        <b className="in_short">Need a room?</b>
        Competition for good rooms is fierce, particularly in busy areas. Early
        Bird Access gives you a 7 day head start.
      </p>
      <p>
        <b className="in_short">Have a room to fill?</b>
        Early Bird Access lets you contact all Room Wanted Ads. Pro-active
        landlords who contact room seekers fill their rooms faster than those
        who sit back and wait for {props.localisations.enquiries}.
      </p>
    </div>
  </div>
);

export default UpgradingBenefits;
